import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.model');

    core.constant(
        'ORDER_PARAM',
        Object.freeze({
            // Définition des sections à afficher
            sectionsOrder: [
                {
                    id: 'buyer',
                    editable: false,
                    categories: ['buyer', 'buyerContact', 'delivery'],
                    initClosed: true,
                },
                {
                    id: 'seller',
                    editable: false,
                    categories: ['seller', 'sellerSubEntity'],
                    initClosed: true,
                },
                {
                    id: 'header',
                    editable: true,
                    categories: ['header', 'root'],
                    initClosed: true,
                },
                {
                    id: 'response',
                    editable: true,
                    categories: ['header', 'root'],
                    initClosed: true,
                },
                {
                    id: 'line',
                    editable: true,
                    categories: ['line'],
                    initClosed: true,
                },
                {
                    id: 'reduction',
                    editable: true,
                    categories: ['reduction'],
                    initClosed: true,
                },
                {
                    id: 'cost',
                    editable: true,
                    categories: ['cost'],
                    initClosed: true,
                },
                {
                    id: 'total',
                    editable: true,
                    categories: [],
                    initClosed: true,
                },
                {
                    id: 'technical',
                    editable: false,
                    categories: ['root', 'technical'],
                    initClosed: true,
                },
            ],
            sectionsResponse: [
                {
                    id: 'header',
                    editable: true,
                    categories: ['header', 'root'],
                    initClosed: true,
                },
                {
                    id: 'line',
                    editable: true,
                    categories: ['line'],
                    initClosed: true,
                },
                {
                    id: 'technical',
                    editable: false,
                    categories: ['root', 'technical'],
                    initClosed: true,
                },
            ],
            sectionsDesadv: [
                {
                    id: 'despatch',
                    editable: false,
                    categories: ['despatch'],
                    initClosed: true,
                },
                {
                    id: 'delivery',
                    editable: false,
                    categories: ['delivery'],
                    initClosed: true,
                },
                {
                    id: 'header',
                    editable: true,
                    categories: ['header', 'root'],
                    initClosed: true,
                },
                {
                    id: 'line',
                    editable: true,
                    categories: ['line'],
                    initClosed: true,
                },
                {
                    id: 'packaging',
                    editable: true,
                    categories: ['line.package'],
                    initClosed: true,
                },
                {
                    id: 'technical',
                    editable: false,
                    categories: ['root', 'technical', 'line.package'],
                    initClosed: true,
                },
            ],
            sectionsRecadv: [
                {
                    id: 'despatch',
                    editable: false,
                    categories: ['despatch'],
                    initClosed: true,
                },
                {
                    id: 'delivery',
                    editable: false,
                    categories: ['delivery'],
                    initClosed: true,
                },
                {
                    id: 'header',
                    editable: true,
                    categories: ['header', 'root'],
                    initClosed: true,
                },
                {
                    id: 'line',
                    editable: true,
                    categories: ['line'],
                    initClosed: true,
                },
                {
                    id: 'technical',
                    editable: false,
                    categories: ['root', 'technical'],
                    initClosed: true,
                },
            ],
            presenceOptions: [
                {
                    value: 'Oui',
                    visible: true,
                },
                {
                    value: 'Non',
                    visible: false,
                },
            ],
        })
    );
})();
